import React from 'react';
import DVCard from 'components/Meteorology/Agro/WaterBalanceCulture/DetailedView/DVCard';
import DVCardMobile from 'components/Meteorology/Agro/WaterBalanceCulture/DetailedView/DVCard/Mobile';
import GroupLocationDeleteFeedback from 'components/Meteorology/Agro/GroupLocationDeleteFeedback';
import useIsMobile from 'utils/hooks/useIsMobile';

export default function DetailedView() {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <>
        <GroupLocationDeleteFeedback />
        <DVCardMobile />
      </>
    );
  }

  return (
    <>
      <GroupLocationDeleteFeedback />
      <DVCard />
    </>
  );
}
